import styles from '@styles/bread_crumb.module.scss';
import { buildBreadcrumbJsonLd } from '@utils/breadcrumbJsonLd';
import { Breadcrumb } from 'antd';
import Link from 'next/link';
import React from 'react';
import { JsonLd } from './JsonLd';

type BreadCrumbItem = {
  title: string;
  url?: string | null;
};

type Props = {
  items: BreadCrumbItem[];
};

const BreadCrumb: React.FC<Props> = ({ items }) => {
  const breadcrumbItems = [
    { title: <Link href="/">Home</Link> },
    ...items.map((item) => ({
      title: item.url ? <Link href={item.url}>{item.title}</Link> : item.title,
    })),
  ];

  return (
    <>
      <JsonLd data={buildBreadcrumbJsonLd(items.map((item) => ({ name: item.title, url: item.url })))} />
      <Breadcrumb className={styles.container} items={breadcrumbItems} />
    </>
  );
};

export type { BreadCrumbItem };
export { BreadCrumb };
